import { useState } from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/logo_copiaazul.png';
import fileIcon from '../assets/file.png';
import bookIcon from '../assets/book.png';
import './Navigation.css';

const Navigation = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <nav className="nav-bar">
      {/* Brand Logo and Title */}
      <div className="nav-brand">
        <Link to="/" className="brand-link">
          <img src={logo} alt="WCAIS Logo" className="nav-logo" />
          <span
            className="nav-title"
            style={{
              background: 'linear-gradient(to right, #ffffff, #66f2f2)',
              WebkitBackgroundClip: 'text',
              backgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              display: 'inline-block',
            }}
          >
            What-can-AI-see?
          </span>
        </Link>
      </div>

      {/* Hamburger Menu Icon (Visible on Mobile) */}
      <div className="menu-icon" onClick={toggleMenu}>
        ☰
      </div>

      {/* Navigation Links (Hidden on Mobile when Menu is Closed) */}
      <div className={`nav-center ${isMenuOpen ? 'open' : ''}`}>
        <Link to="/docs" className="nav-link">
          <img src={fileIcon} alt="Docs" className="nav-icon" />
          Docs
        </Link>
        <Link to="/manual" className="nav-link">
          <img src={bookIcon} alt="Manual" className="nav-icon" />
          Manual
        </Link>
      </div>

      {/* Get Started Button (Hidden on Mobile when Menu is Closed) */}
      <Link to="/app" className={`get-started-btn ${isMenuOpen ? 'open' : ''}`}>
        Get Started
      </Link>
    </nav>
  );
};

export default Navigation;